import React from "react";
import { FaUserFriends, FaSchool, FaFileAlt, FaHandshake, FaMoneyCheckAlt, FaPassport, FaHome, FaCalendarCheck, FaGraduationCap } from "react-icons/fa";
import { MdHelpOutline, MdEditDocument } from "react-icons/md";
import { GiTakeMyMoney } from "react-icons/gi";
import { RiVisaLine } from "react-icons/ri";
import "./PremiumCounselling.css"; 

const services = [
  { icon: <FaUserFriends />, title: "How to Study Abroad", desc: "Step-by-step guidance from University selection to settling in." },
  { icon: <FaSchool />, title: "How to Apply to Study Abroad", desc: "Detailed application support for undergraduate, postgraduate, and specialized courses." },
  { icon: <MdHelpOutline />, title: "How to Apply for Foreign Universities", desc: "Shortlisting, SOP guidance, and interview preparation." },
  { icon: <MdEditDocument />, title: "How to Apply for a Scholarship to Study Abroad", desc: "Helping you secure study abroad scholarships for Indian students and international funding opportunities." },
  { icon: <FaFileAlt />, title: "Abroad Scholarships", desc: "Finding study abroad grants, fellowships, and financial aid programs." },
  { icon: <GiTakeMyMoney />, title: "Study Abroad after 12th", desc: "Helping fresh graduates choose the right academic track." },
  { icon: <FaHandshake />, title: "MBA Abroad", desc: "Admission guidance for top global business schools." },
  { icon: <FaGraduationCap />, title: "MS Abroad", desc: "Expert guidance for securing admission to top global universities for your Master's degree." }

];

const PremiumCounselling = () => {
  return (
    <div className="container text-center my-5">
      <h2 className="fw-bold heading">Why Choose Our Premium Counselling?</h2>
      <p className="text-muted">Studying in a different country is a life-changing experience, but it comes with challenges like admission processes, visa applications, financial planning, and cultural adjustments. Our expert team provides each student a personal career coach who helps you achieve your academic goals and career aspirations. With Nova EduBridge, you don’t just get career consultancy, you get a lifelong partner in your academic and professional growth.
</p>

      <div className="row g-3 mt-4 justify-content-center">
        {services.map((service, index) => (
          <div className="col-12 col-md-3" key={index}>
            <div className={`service-cardd ${service.highlight ? "highlight" : ""}`}>
              <div className="icon">{service.icon}</div>
              <h3>{service.title}</h3>
              <p>{service.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PremiumCounselling;
